"use strict";

window.murmel = window.murmel || {};
window.murmel.glideSliders = window.murmel.glideSliders || [];
window.murmel.subscribers = {};
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
function subscribe(eventName, callback) {
  if (window.murmel.subscribers[eventName] === undefined) {
    window.murmel.subscribers[eventName] = [];
  }
  window.murmel.subscribers[eventName] = [...window.murmel.subscribers[eventName], callback];
  return function unsubscribe() {
    window.murmel.subscribers[eventName] = window.murmel.subscribers[eventName].filter(cb => {
      return cb !== callback;
    });
  };
}
function publish(eventName, data) {
  if (window.murmel.subscribers[eventName]) {
    window.murmel.subscribers[eventName].forEach(callback => {
      callback(data);
    });
  }
}
window.murmel.addToCartAndUpdate = function (event) {
  let quantity = 1;
  const productDataForm = event.target.closest(`[data-type="add-to-cart-form"]`) || event.target.closest("[data-product-form]");
  const formData = new FormData(productDataForm);
  const addUrl = window.Shopify.routes.root + "cart/add.js";
  const dataJs = event.target.closest(`[data-js="add-to-cart-btn"]`);
  const hiddenId = event.target.querySelector(`input[type="hidden"][name="id"]`);
  const cartContent = document.querySelector(".js-header-cart-content");
  const iconBubble = document.querySelector("#cart-icon-bubble");
  const productInfoContainer = event.target.closest(`.product__info-container`);
  if (productInfoContainer) {
    const quantityInput = productInfoContainer.querySelector(`[name="quantity"]`);
    if (quantityInput) {
      quantity = Number(quantityInput.value);
    }
  }
  const cartItemsContainer = document.querySelector(".js-shopify-section-cart-items");
  const cartItemsId = cartItemsContainer?.getAttribute("id")?.replace('shopify-section-', "");
  const cartFooterContainer = document.querySelector(".js-shopify-section-cart-footer");
  const cartFooterId = cartFooterContainer?.getAttribute("id")?.replace('shopify-section-', "");
  const isCartPage = window.murmel.pageType === "cart";
  formData.set("quantity", quantity);
  formData.set("sections", isCartPage ? `${cartItemsId},${cartFooterId},cart-preview,cart-icon-bubble` : "cart-preview,cart-icon-bubble");
  formData.set("sections_url", window.location.pathname);
  formData.set("form_type", "product");
  formData.set("utf8", "✓");
  if (dataJs) {
    formData.set("id", Number(dataJs.dataset.varId));
  } else if (hiddenId) {
    formData.set("id", Number(hiddenId.value));
  }
  let addResponse;
  fetch(addUrl, {
    method: "POST",
    body: formData
  }).then(res => {
    addResponse = res;
    return res.json();
  }).then(data => {
    if (addResponse.status !== 200) {
      const productForm = event.target.closest("product-form") || event.target.closest("[data-product-form]");
      if (productForm) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: data.errors || data.description,
          message: data.message
        });
        const errorMessageWrapper = productForm?.querySelector(".product-form__error-message-wrapper");
        const errorMessageText = productForm?.querySelector(".product-form__error-message");
        if (data.description && typeof data.description === 'string' || data.description instanceof String) {
          if (errorMessageWrapper) errorMessageWrapper.removeAttribute("hidden");
          if (errorMessageText) errorMessageText.textContent = data.description || "";
        }
      }
      return;
    }
    const bubbleHtml = data?.sections?.["cart-icon-bubble"];
    const previewHtml = data?.sections?.["cart-preview"];
    const cartItemsHtml = data?.sections?.[cartItemsId];
    const cartFooterHtml = data?.sections?.[cartFooterId];
    if (bubbleHtml) {
      const bubble = new DOMParser().parseFromString(bubbleHtml, "text/html").querySelector("#cart-icon-bubble");
      if (bubble) {
        iconBubble.replaceWith(bubble);
      }
    }
    if (previewHtml) {
      cartContent.innerHTML = previewHtml;
      window.headerOpenCartPopup(false);
      if (document.body.classList.contains('gr-scroll-down')) {
        document.body.classList.remove('gr-scroll-down');
        document.body.classList.add('gr-scroll-up');
      }
      let backReference = event.target.closest(`[data-js="add-to-cart-btn"]`);
      if (!backReference) {
        backReference = event.target.querySelector(".js-btn-add-to-cart");
      }
      setTimeout(() => {
        const modalCloseButton = cartContent.querySelector(".modal-close-button");
        if (backReference) {
          modalCloseButton._murmelFocusBackref = backReference;
        }
        modalCloseButton.focus();
        trapFocus(cartContent, modalCloseButton);
      }, 100);
    }
    if (isCartPage && cartItemsHtml) {
      const contents = new DOMParser().parseFromString(cartItemsHtml, "text/html").querySelector(".js-shopify-section-cart-items");
      if (cartItemsContainer && contents) {
        cartItemsContainer.replaceWith(contents);
      }
    }
    if (isCartPage && cartFooterHtml) {
      const contents = new DOMParser().parseFromString(cartFooterHtml, "text/html").querySelector(".js-shopify-section-cart-footer");
      if (cartFooterHtml && contents) {
        cartFooterContainer.replaceWith(contents);
      }
    }
    const existingPopup = document.querySelector('.quick-view-popup');
    if (existingPopup) {
      document.body.removeChild(existingPopup);
      document.body.classList.remove('body-hidden');
    }
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-form',
      productVariantId: formData.get('id'),
      cartData: data
    });
  }).catch(e => {
    console.error(e);
  });
};
window.murmel.handleGlideFocus = function (event) {
  const target = event.target;
  if (!target) return;
  const section = target.closest(".shopify-section");
  if (!section) return;
  const slide = target.closest(`[data-glide-index]:not(.glide__slide--clone)`);
  if (!slide) return;
  const glide = window.murmel.glideSliders.find(g => g.selector == "#" + section.id)?.glide;
  if (!glide) return;
  glide.go("=" + glide.index);
};
document.body.addEventListener("click", function (event) {
  if (event.target.id === "pickup-availability-switch" && event.target?.checked) {
    setTimeout(() => {
      const drawerContent = document.querySelector(".pickup-availability-preview");
      trapFocus(drawerContent);
    }, 50);
  }
  const target = event.target.closest(`[data-js]`);
  if (!target) return;
  if (target.dataset.js == "add-to-cart-btn") {
    event.preventDefault();
    event.stopPropagation();
    window.murmel.addToCartAndUpdate(event);
  }
  if (target.dataset.js == "product-quick-view") {
    event.preventDefault();
    event.stopPropagation();
    window.murmel.handleQuickViewClick(event);
  }
  if (target.dataset.js == "quick-view-toggle") {
    event.preventDefault();
    event.stopPropagation();
    window.murmel.quickViewToggle(event);
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('.glide__slide--clone .shopify-payment-button__button[type="button"]');
  buttons.forEach(function (button) {
    button.setAttribute('tabindex', '-1');
  });
});
document.addEventListener("shopify:section:load", function (event) {
  window.murmel.extractColors();
  const section = event.target;
  const sectionSelector = "#" + (section?.id || "---");
  const slider = window.murmel.glideSliders.find(x => x.selector == sectionSelector);
  if (slider) {
    slider.glide = new Glide(sectionSelector, slider.config);
    slider.events.forEach(event => {
      slider.glide.on(event.name, event.handler);
    });
    slider.glide.mount();
  } else {
    const glideScript = section.querySelector("[data-glide-script]");
    const newScript = document.createElement("script");
    newScript.innerHTML = glideScript.innerHTML;
    glideScript.insertAdjacentElement("afterend", newScript);
    glideScript.remove();
  }
});
document.addEventListener("shopify:section:unload", function (event) {
  const section = event.target;
  const sectionSelector = "#" + (section?.id || "---");
  const slider = window.murmel.glideSliders.find(x => x.selector == sectionSelector);
  if (slider && slider.glide) {
    slider.glide.destroy();
    delete slider.glide;
  }
});
document.addEventListener("shopify:block:select", function (event) {
  const section = event.target.closest(".shopify-section");
  const sectionSelector = "#" + (section?.id || "---");
  const slider = window.murmel.glideSliders.find(x => x.selector == sectionSelector);
  const slideIndex = +event.target.dataset.glideIndex;
  if (slider && slider.glide) {
    slider.glide.go("=" + slideIndex);
  }
});
function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container) {
  let elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });
  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus() {
  let elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    });
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
  var _this = this;
  let t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(() => fn.apply(_this, args), wait);
  };
}
function fetchConfig() {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'json';
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event) {
    let elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }
  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent() {
    let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url).then(response => response.text()).then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
        const glideScript = this.querySelector("[data-glide-script]");
        if (glideScript) {
          const newScript = document.createElement("script");
          newScript.innerHTML = glideScript.innerHTML;
          glideScript.insertAdjacentElement("afterend", newScript);
          glideScript.remove();
        }
      }).catch(e => {
        console.error(e);
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px'
    }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);